import styled from 'styled-components';

export const StyledSign = styled.div`
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg1[0]};
`;
